if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 150));

        this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((thumbnail) => {
          thumbnail
            .querySelector('button')
            ?.addEventListener('click', this.setActiveMedia.bind(this, thumbnail.dataset.target, false));
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const currentElement = event.detail?.currentElement;
        if (!currentElement) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((media) => {
          media.classList.toggle('is-active', media === currentElement);
        });

        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }

        this.playActiveMedia(currentElement);
      }

      setActiveMedia(mediaId, prepend) {
        const viewerSlider = this.elements.viewer.slider;
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((media) => {
          media.classList.toggle('is-active', media === activeMedia);
        });

        if (prepend) {
          if (activeMedia.parentElement.firstElementChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement.firstElementChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          this.elements.viewer.resetPages?.();
        }

        this.preventStickyHeader();

        requestAnimationFrame(() => {
          if (viewerSlider) {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            viewerSlider.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: reduceMotion ? 'auto' : 'smooth',
            });
          }

          const mediaRect = activeMedia.getBoundingClientRect();
          if (mediaRect.top < -0.5) {
            window.scrollTo({
              top: mediaRect.top + window.scrollY,
              behavior: 'smooth',
            });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((button) => {
          button.removeAttribute('aria-current');
        });
        thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');

        const thumbnailSlider = this.elements.thumbnails.slider;
        if (!thumbnailSlider) return;

        const isVisible = this.elements.thumbnails.isSlideVisible?.(thumbnail, 10);
        if (!isVisible) {
          thumbnailSlider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
        }
      }

      announceLiveRegion(activeMedia, position) {
        const image = activeMedia.querySelector('.product__modal-opener--image img');
        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);

          window.setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeMedia) {
        window.pauseAllMedia();
        activeMedia.querySelector('.deferred-media')?.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
